
  <template>
  <div
    class="component-wrapper d-flex flex-column align-center justify-space-between white"
  >
    <div
      class="d-flex flex-column pa-10 align-center rounded elevation-2 mb-16"
    >
      <div class="mb-3" @click="$router.push('/login')">
        <img src="../assets/logotitle.png" alt="logo" class="logo" />
      </div>

      <div
        class="secondary--text mb-8 text-center text-sm-h5 text-md-h5 text-body-1 font-weight-bold"
      >
        ΥΠΟΒΟΛΗ ΕΚΘΕΣΕΩΝ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ ΧΡΗΜΑΤΑΓΟΡΑΣ
      </div>

      <v-form
        @submit.prevent="onSubmit"
        class="d-flex flex-column justify-center mb-auto form"
      >
        <v-text-field
          v-model="password"
          label="Νέος κωδικός"
          type="password"
          solo
          class="rounded primary--text"
          :error-messages="passwordErrors"
        ></v-text-field>

        <v-text-field
          v-model="passwordConfirmation"
          label="Επιβεβαίωση κωδικού"
          type="password"
          solo
          class="rounded"
          :error-messages="passwordConfirmationErrors"
        ></v-text-field>

        <v-btn type="submit" class="primary py-6" :loading="loader">
          Αλλαγή κωδικού
        </v-btn>
      </v-form>
    </div>

    <!-- <Alert v-if="showAlert" :items="alertItems" class="mt-auto"></Alert> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      loader: false,
      password: "",
      passwordConfirmation: "",
    };
  },

  validations: {
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(12),
    },
    passwordConfirmation: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.password.minLength) errors.push("Τουλάχιστον 4 χαρακτήρες");
      if (!this.$v.password.maxLength) errors.push("Μέχρι 12 χαρακτήρες");

      return errors;
    },

    passwordConfirmationErrors() {
      const errors = [];
      if (!this.$v.passwordConfirmation.$dirty) return errors;
      if (!this.$v.passwordConfirmation.required)
        errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.passwordConfirmation.sameAsPassword)
        errors.push("Οι κωδικοί δεν ταιριάζουν. Δοκιμάστε ξανά");
      return errors;
    },
  },

  methods: {
    ...mapActions(["setNewPassword"]),

    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;
        const token = this.$router.currentRoute.path.split("/newpass/")[1];
        await this.setNewPassword({
          newPassword: this.password,
          token,
        });
        this.loader = false;
        this.$router.push("/login");
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 400px;
}

.logo {
  max-width: 100%;
  cursor: pointer;
}

.svg {
  width: 200px;
}

@media only screen and (max-width: 960px) {
  // .logo {
  //   width: 700px;
  // }
}

@media only screen and (max-width: 600px) {
  .form {
    width: 70%;
  }
  .logo {
    width: 100%;
  }
  .svg {
    width: 150px;
  }
}
</style>